
import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from 'app/shared/global.service';
@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit {

  @Input() paymentDetails: any;
  @Input() orderDetails: any;
  @Input() customDetails: any;

  constructor(public globals: GlobalService) { }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  ngOnInit(): void {
    // console.log(this.paymentDetails);
    // console.log(this.orderDetails);
    // console.log(this.customDetails);
  }

  GetBack() {
    // Hide payment History
    if (this.globals.isPaymentHistory && this.globals.UserName != "" && !this.globals.isPaymentDetails) {
      this.globals.isPaymentHistory = false;
    }
    // Hide payment details and show 
    else if (this.globals.isPaymentHistory && this.globals.UserName != "" && this.globals.isPaymentDetails) {
      this.globals.isPaymentHistory = true;
      this.globals.isPaymentDetails = false;
    }
  }
}
